module.exports = __webpack_public_path__ + "img/fa.d435851f.png";